import { render } from "./IngredientsFilterPage.vue?vue&type=template&id=43b82de4&scoped=true"
import script from "./IngredientsFilterPage.vue?vue&type=script&lang=js"
export * from "./IngredientsFilterPage.vue?vue&type=script&lang=js"

import "./IngredientsFilterPage.vue?vue&type=style&index=0&id=43b82de4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b82de4"]])

export default __exports__